module.exports = { "default": require("core-js/library/fn/array/from"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// /Users/gtirby/develop/~/babel-runtime/core-js/array/from.js
// module id = 272
// module chunks = 0